export enum MapEventEntityTypes {
  LOCATION = 'location',
  CHANNEL = 'channel',
}
